import { capturePrivateSession, assertPrivateSessionLifetime } from "@/lib/api/private-session";
import { useSessionMutation as useMutation } from "@/lib/query/core/use-session-mutation";
import { useQueryClient } from "@tanstack/react-query";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { changePrivateSession } from "./privateSessionChange";
import { prepareSellerNotificationLogout } from "@/lib/firebase/fcm";

type SellerLogoutInput = {
  storeSlug?: string;
};

export function useLogoutMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    meta: { skipGlobalErrorToast: true },
    mutationFn: async (input: SellerLogoutInput = {}) => {
      const lifetime = capturePrivateSession();
      void input.storeSlug;
      // This is intentionally centralized here: AppShell, BottomNav, the
      // account page, mobile settings, and the restaurant-store terminal all
      // use this mutation. Notification cleanup runs while the cookie still
      // exists, then Firebase Auth is cleared before server logout.
      await prepareSellerNotificationLogout();
      assertPrivateSessionLifetime(lifetime);
      return changePrivateSession(queryClient, () => apiJsonClient<unknown>(endpoints.seller.auth.logout, {
        method: "POST",
      }));
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
